<template>
  <div id="app">
    <!-- {{$utils.timestampToStr(nowDate, 'Y/M/D h:m:s')}} -->
    <!-- 首页头部 -->
    <!--<div class="stopTaking">-->
    <!--  <img src="https://img.webloom.cn/Img/laba.png" alt="" class="stopImg">-->
    <!--  系统维护通知：Bloom将于 <span class="fontBold">6月12日（周四）凌晨 00:00-08:00 进行升级维护</span>。期间有数据丢失风险，请勿在此时间段进行操作。-->
    <!--</div>-->
    <header-box :key="isChange" @logout="logout"></header-box>
    <router-view v-if="isRouterAlive" :key="$route.path.indexOf('/TaskSublist/') > -1 ? '/TaskSublist/' : $route.path + $route.query.t" />
    <!-- 全局的按钮 -->
    <all-btn v-if="bol" ref="allBtn"></all-btn>
    <!-- BLOOM平台调研问卷（全局宿主） -->
    <bloom-survey-dialog ref="bloomSurveyDialog" />
  </div>
</template>

<script>
import {netWorkQuality} from './components/bloom-proctor/public/netWork'
import HeaderBox from '@public/header-box'
import { mapState, mapMutations } from 'vuex'
// import config from '@assets/config'
import AllBtn from '@public/all-btn'
import BloomSurveyDialog from '@public/BloomSurveyDialog'
import { setBloomSurveyHost } from './plugin/BloomSurveyDialog/host'
import { tryShowBloomSurveyDialog, suppressBloomSurveyOnExamRoute } from './plugin/BloomSurveyDialog/pending'

// 与 index.html 中 CNZZ 数据层一致，未加载时 push 到队列
let _czc = window._czc || []
export default {
  name: 'App',
  computed: mapState({
    nowDate: state => state.common.nowDate,
    timeDifference: state => state.common.timeDifference,
    isChange: state => state.useData.isChange,
    nowTestStatus: state => state.proctor.nowTestStatus
  }),
  components: {
    HeaderBox,
    AllBtn,
    BloomSurveyDialog
  },
  watch: {
    nowTestStatus: {
      immediate: true,
      deep: true,
      handler: function (val) {
        if (val && val.examId && val.magType && this.$route.query.examId) {
          if (val.examId === this.$route.query.examId) {
            let type = val.magType === 201 ? 3 : val.magType === 202 ? 4 : 1
            this.$router.replace({
              path: '/ExamSystemMiss',
              query: {
                type: type,
                examId: this.$route.query.examId
              }
            })
          }
        }
      }
    },
    // 但和服务器时间同步时，更新本地时间
    'timeDifference' () {
      let time = new Date().getTime() + this.timeDifference
      this.set_nowDate(time)
    },
    $route () {
      if (this.$route.name === 'OrganizeIndex' || this.$route.name === 'SocietyIndex') {
        this.bol = false
      } else  {
        this.bol = true
      }
      // 考试页：关掉误开的问卷并保留标记；离开考试页后再补弹
      if (suppressBloomSurveyOnExamRoute(this)) return
      tryShowBloomSurveyDialog(this)
      // 判断 _czc 有没有挂载，且当前环境是开发还是生产，测试的时候，使用开发环境，上线之前记得改成生产，避免消息发送错误
      if (_czc) {
        // 如果使用_trackPageview改写了已有页面的URL，建议在CNZZ的JS统计代码执行前先调用_setAutoPageview，将该页面的自动PV统计关闭，防止页面的流量被统计双倍。
        // _czc.push(['_trackPageview', contentUrl, refererUrl]);

        // 获取当前页面的信息
        let location = window.location

        // 代表当前路由地址
        let contentUrl = location.pathname + location.hash

        // 代表当前页面的母页面，不填，按母页面的来路计算，但是实际上是取不到母页面的
        let refererUrl = '/'
        // 发送统计事件，
        _czc.push(['_trackPageview', contentUrl, refererUrl])
      }
    }
  },
  data () {
    return {
      isRouterAlive: true,
      bol: true,
      timeInterval: null
    }
  },
  provide () {
    return {
      reload: this.reload
    }
  },
  methods: {
    // 退出登录
    logout () {
      this.$refs.allBtn.init()
    },
    reload () {
      this.isRouterAlive = false
      // console.warn('触发了')
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
    },
    // 更新当前时间
    ...mapMutations([
      'set_nowDate'
    ]),
    // 初始化
    init () {
      // 挂载更新全局的当前时间一直随时间变化
      let time = new Date().getTime() + this.timeDifference
      this.set_nowDate(time)
      this.timeInterval = setInterval(() => {
        time = new Date().getTime() + this.timeDifference
        this.set_nowDate(time)
      }, 1000)
    }
  },
  mounted () {
    if (process.env.BUILD_REGION === 'intl' || process.env.LANG_LOCKED === 'true') {
      this.$i18n.locale = 'en'
      this.$utils.cache('bloom:lang', 'en')
    } else {
      let lang = (navigator.language || navigator.browserLanguage).toLowerCase()
      let language = 'en'
      if (lang.indexOf('zh') !== -1) {
        // 浏览器语言是中文
        language = 'zh'
      }
      this.$i18n.locale = this.$utils.cache('bloom:lang') ? this.$utils.cache('bloom:lang') : language
      this.$utils.cache('bloom:lang', this.$i18n.locale)
    }
    // window.addEventListener('beforeunload', this.beforeunloadHandler)
    // window.addEventListener('unload', this.unloadHandler)
    netWorkQuality()
    if (this.$refs.bloomSurveyDialog) {
      setBloomSurveyHost(this.$refs.bloomSurveyDialog)
    }
    if (!suppressBloomSurveyOnExamRoute(this)) {
      tryShowBloomSurveyDialog(this)
    }
  },
  created () {
    this.init()
    // const version = config.version
    // if ((window.location.hash === '#/') && (this.$utils.cache('version') !== version)) {
    //   localStorage.clear()
    //   this.$utils.cache('version', version)
    // } else if ((window.location.hash === '#/')) {
    //   this.$utils.cacheClear()
    // }
  },
  beforeDestroy () {
    // 清除定时器，防止内存泄漏
    if (this.timeInterval) {
      clearInterval(this.timeInterval)
      this.timeInterval = null
    }
    setBloomSurveyHost(null)
    // 移除window事件监听器，防止内存泄漏
    // window.removeEventListener('beforeunload', this.beforeunloadHandler)
    // window.removeEventListener('unload', this.unloadHandler)
  }
}
</script>

<style lang="less">
@import './assets/less/common.less';
</style>

<style lang="less" scoped>
#app{
  min-height: 100%;
  height: 100vh;
  .stopTaking{
    position: fixed;
    top: 0;
    width: 100%;
    background: #FFFCEF;
    height: 36px;
    line-height: 36px;
    z-index: 999999999999;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: rgba(143, 101, 53, 1);
    font-family: PingFangSC-Regular;
    .stopImg {
      display: inline-block;
      width: 19px;
      height: 16px;
      margin-right: 9px;
    }
    .fontBold {
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: bolder;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue